
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmanchar() {



    const cardData =
    {
        keyword: 'Cab Service in Manchar',
        heading: 'Platinum24 Cabs: Cab Service in Manchar',
        headingDescription: ' Platinum24 Cabs offers dependable Cab Service in Manchar, providing safe and comfortable travel solutions for local commutes, business travel, airport transfers, and outstation trips. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth ride for individuals, families, and corporate clients alike. With experienced chauffeurs, punctual service, and transparent pricing, we make every journey stress-free. Whether you’re traveling within Manchar or planning long-distance travel to Pune, Mumbai, Nashik, or nearby destinations, Platinum24 Cabs guarantees affordability, reliability, and complete customer satisfaction.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it witnessed the glory of Bajirao and Mastani. The grand gates, fountains, and gardens still narrate Maratha history. Though partially destroyed by fire in 1828, it remains a heritage symbol. The evening light-and-sound show revives tales of bravery. Shaniwar Wada is Pune’s proud cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum with Gandhi’s belongings and photographs. Its sprawling lawns and Italian arches make it architecturally elegant. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historic inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Located atop a hill, it offers trekking trails and Sahyadri valley views. Visitors explore bastions, temples, and memorials of Maratha bravery. Monsoon adds mist and waterfalls to the experience. Local villagers serve authentic pithla-bhakri meals at the summit. Sinhagad is Pune’s heritage adventure spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine of Lord Ganesha. The grand idol is richly adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of massive festivities. It is also known for its charitable and cultural works. Devotees from across India visit for blessings. Dagdusheth Temple is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it provides a peaceful retreat. Evening prayers add to its mystical charm. The carvings reflect ancient Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and antiques of daily use. The recreated Mastani Mahal is a major highlight. Students and history lovers find it educational and fascinating. It preserves centuries of Indian tradition and culture. This museum is Pune’s proud showcase of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets here are breathtaking. Parvati Hill is Pune’s sacred scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global wellness and spirituality hub. Spread across serene gardens, it offers meditation, yoga, and growth workshops. Zen-inspired landscapes and modern facilities attract seekers from around the world. Visitors experience peace, rejuvenation, and mindfulness. It blends spirituality with a modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families and couples enjoy picnics, nature walks, and photography here. Seasonal flowers and manicured gardens add to its charm. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s peaceful green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend spot near Pune. It provides water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a breathtaking picnic destination. Vendors selling hot corn and tea enhance the experience. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s natural retreat of refreshment."
  }
],


       "services": [
    {
      "name": "Manchar Cab Service",
      "description": "Our Manchar Cab Service offers convenient and comfortable transportation for residents, tourists, and business travelers in and around Manchar. Whether you're heading to a local market, visiting nearby towns, or commuting for work, our cabs ensure timely pickups, courteous drivers, and safe rides. With multiple vehicle options including hatchbacks, sedans, and SUVs, we cater to individual and group travel. Enjoy reliable, clean, and GPS-enabled cabs at competitive prices—bookable anytime with 24x7 support for a smooth travel experience."
    },
    {
      "name": "Taxi Service Manchar",
      "description": "Taxi Service Manchar is your trusted option for all types of local and intercity travel needs. Whether you need a taxi for office commutes, errands, or weekend plans, we provide fast, secure, and comfortable rides. Our drivers are well-acquainted with Manchar’s routes and provide hassle-free navigation across all neighborhoods. With fixed rates, online booking, and round-the-clock availability, this service is ideal for families, professionals, and visitors alike."
    },
    {
      "name": "Manchar Local Taxi",
      "description": "For short-distance and within-town travel, our Manchar Local Taxi service is the perfect solution. Whether you're running errands, attending appointments, or visiting local attractions, we offer quick and affordable travel around Manchar. Choose from compact cars for solo rides or larger vehicles for group travel. Our professional drivers, clean vehicles, and affordable rates ensure a seamless and pleasant local travel experience."
    },
    {
      "name": "Affordable Taxi Manchar",
      "description": "Travel smart with our Affordable Taxi Manchar service, ideal for those seeking budget-friendly travel without compromising on quality. We offer low fares, fuel-efficient vehicles, and flexible plans for short or long journeys. Whether you need a daily commute option or a one-time pickup, our transparent pricing and well-maintained taxis make everyday travel both convenient and economical."
    },
    {
      "name": "Manchar Taxi with Driver",
      "description": "With our Manchar Taxi with Driver service, you get a comfortable car and a professional chauffeur who handles navigation, traffic, and route planning for you. Ideal for tourists, senior citizens, and corporate professionals, our driver-inclusive taxis offer a worry-free travel experience. Whether it’s a few hours or an entire day, enjoy smooth rides with drivers who are courteous, punctual, and well-versed with local roads."
    },
    {
      "name": "Manchar Airport Taxi",
      "description": "Need a ride to or from Pune or Mumbai airport? Our Manchar Airport Taxi service offers punctual and stress-free airport transfers. We monitor flight timings to ensure timely pickups and drop-offs. Whether you're traveling for business or leisure, enjoy spacious vehicles, luggage assistance, and fixed rates with no hidden fees. Early morning or late-night flight? We’re available 24x7 to serve your airport travel needs."
    },
    {
      "name": "Cab Rental Manchar",
      "description": "Our Cab Rental Manchar service provides flexible rental options for local or outstation needs. Choose from hourly, daily, or long-term rentals with or without a driver. Ideal for weddings, business travel, sightseeing, or family trips — we offer a range of vehicles to suit your requirements. With clean, sanitized cars and transparent billing, you can rent confidently and travel comfortably across Maharashtra and beyond."
    },
    {
      "name": "Manchar Outstation Taxi",
      "description": "Planning a trip out of town? Book a Manchar Outstation Taxi for a safe and smooth intercity journey. We offer one-way and round-trip travel to Pune, Nashik, Mumbai, Shirdi, and other major destinations. Our vehicles are comfortable, reliable, and handled by experienced drivers familiar with long-distance routes. Ideal for leisure travel, pilgrimages, or business visits — with clear pricing and full support throughout your journey."
    },
    {
      "name": "Manchar Corporate Taxi",
      "description": "Our Manchar Corporate Taxi service caters to business professionals and companies looking for dependable travel solutions. Whether it’s employee transport, client pickups, or executive transfers, we offer high-quality vehicles and professionally trained drivers. Enjoy features like monthly billing, GST-compliant invoices, and priority support tailored for corporate accounts. Choose our corporate taxi service to enhance your organization’s travel efficiency."
    },
    {
      "name": "Manchar Taxi Deals",
      "description": "Save more on your rides with exclusive Manchar Taxi Deals. We offer seasonal discounts, referral benefits, first-time user offers, and package deals for round-trips and long-distance bookings. Whether you’re a frequent rider or planning a one-time trip, our deals ensure you get great value without sacrificing comfort or service quality. Check our app or website regularly to stay updated on new offers."
    },
    {
      "name": "Manchar Family Taxi Service",
      "description": "Travel together with ease using our Manchar Family Taxi Service. Designed for family outings, temple visits, vacations, and special occasions, we provide large and comfortable vehicles with family-friendly features like child locks, booster seats (on request), and extra luggage space. Our drivers are courteous, safe, and helpful, making your trip stress-free and enjoyable for all age groups."
    },
    {
      "name": "Taxi Booking Online Manchar",
      "description": "Book a taxi from anywhere, anytime with our Taxi Booking Online Manchar platform. Our mobile-friendly booking system allows you to select your car, schedule pickups, track your ride, and make secure payments in just a few clicks. No calls, no waits — just fast and simple booking with instant confirmation. Enjoy peace of mind with real-time tracking, ride history, and 24x7 support."
    },
    {
      "name": "Manchar Taxi Service 24x7",
      "description": "Our Manchar Taxi Service 24x7 ensures you have access to reliable transportation at any hour of the day or night. Whether it's a late-night arrival, an early-morning flight, or an emergency trip, we’re always available. Our drivers are trained for night driving, and our vehicles are equipped for safety and comfort. Trust us to be your go-to travel partner — anytime, anywhere in and around Manchar."
    }
  ],
  "tableData": [
    ["Manchar Cab Service", "Taxi Service Manchar"],
    ["Manchar Local Taxi", "Affordable Taxi Manchar"],
    ["Manchar Taxi with Driver", "Manchar Airport Taxi"],
    ["Cab Rental Manchar", "Manchar Outstation Taxi"],
    ["Manchar Corporate Taxi", "Manchar Taxi Deals"],
    ["Manchar Family Taxi Service", "Taxi Booking Online Manchar"],
    ["Manchar Taxi Service 24x7", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service in Manchar",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and affordable cab services in Manchar for all your local and outstation travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Travel",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers tailored for your group size and comfort."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles for Safety",
    "WhyChoosedescription": "All our vehicles are regularly cleaned and sanitized to ensure a safe and comfortable journey in Manchar."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Manchar Routes",
    "WhyChoosedescription": "Our professional drivers have in-depth knowledge of Manchar and surrounding areas for smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent pricing that includes fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Manchar cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Choose hourly, daily, or long-term rental plans tailored to your specific travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Manchar cab quickly and securely through our website or app with instant confirmation."
  }
]



















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Manchar?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services in Manchar for all your local and outstation travel needs.',
    },
    {
        question: 'How can I book a cab service in Manchar with Platinum24 Cabs?',
        answer: 'You can easily book a cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab service in Manchar?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your travel requirements.',
    },
    {
        question: 'Can I use the cab service in Manchar for both local and outstation trips?',
        answer: 'Yes, Platinum24 Cabs offers cab services for local travel within Manchar as well as outstation journeys.',
    },
    {
        question: 'Are the drivers experienced and knowledgeable about Manchar routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and well-versed with routes in and around Manchar.',
    },
    {
        question: 'Is hourly and daily cab service available in Manchar?',
        answer: 'Yes, we provide flexible hourly and daily cab rental packages tailored to your needs.',
    },
    {
        question: 'Are the cabs sanitized and safe for passengers in Manchar?',
        answer: 'Yes, all vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene protocols.',
    },
    {
        question: 'Is cab service in Manchar available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Manchar.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Manchar?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for easy and secure transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Manchar?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Manchar.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Pawar',
        feedback: 'Platinum24 Cabs provided excellent cab service in Manchar. The driver was punctual and friendly.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita More',
        feedback: 'Very comfortable and safe rides with Platinum24 Cabs in Manchar. Highly recommend their service.',
        rating: 5,
    },
];











































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const mancharCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Manchar offering local taxis, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver, available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Manchar, Pune"
  },
  "serviceType": [
    "Manchar Cab Service",
    "Taxi Service Manchar",
    "Manchar Local Taxi",
    "Affordable Taxi Manchar",
    "Manchar Taxi with Driver",
    "Manchar Airport Taxi",
    "Cab Rental Manchar",
    "Manchar Outstation Taxi",
    "Manchar Corporate Taxi",
    "Manchar Taxi Deals",
    "Manchar Family Taxi Service",
    "Taxi Booking Online Manchar",
    "Manchar Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};




    return (
        <div>


<Helmet>
  <title>Cab Service in Manchar | Affordable Taxi Service Manchar Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Manchar offering local taxis, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver, available 24x7."
  />
  <meta
    name="keywords"
    content="Manchar Cab Service, Taxi Service Manchar, Manchar Local Taxi, Affordable Taxi Manchar, Manchar Taxi with Driver, Manchar Airport Taxi, Cab Rental Manchar, Manchar Outstation Taxi, Manchar Corporate Taxi, Manchar Taxi Deals, Manchar Family Taxi Service, Taxi Booking Online Manchar, Manchar Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(mancharCabServiceSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/92.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinmanchar;